import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { PageContext, RedirectorPaynowConfig } from 'src/app/service/redirector.service'
import { PaynowFrequentQuestions } from 'src/static/content/paynow-faq.questions'
import { IconComponent } from 'src/app/elements/icon/icon.component'
import { NgStyle } from '@angular/common';
import { PriceComponent } from 'src/app/elements/price/price.component'
import { TooltipComponent } from 'src/app/elements/tooltip/tooltip.component'
import { ButtonComponent } from 'src/app/elements/button/button.component'
import { PaymentMethodsComponent } from 'src/app/elements/payment-methods/payment-methods.component'
import { ContentBlockComponent } from 'src/app/elements/content-block/content-block.component'
import { AccordionComponent } from 'src/app/elements/accordion/accordion.component'
import { PopupComponent } from 'src/app/elements/popup/popup.component'
import { FitTextDirective } from 'src/app/directives/fit-text.directive'
import { Environment } from 'src/environments/environment'
import { PriceSuggestionComponent } from 'src/app/elements/price-suggestion/price-suggestion.component'
import { Subject } from 'rxjs'
import { PaynowBuyButtonsComponent } from 'src/app/elements/paynow-buy-buttons/paynow-buy-buttons.component'
import { UserTokenPipe } from 'src/app/pipes/promo-link.pipe'
import { PaynowFooterComponent } from 'src/app/elements/paynow-footer/paynow-footer.component'

@Component({
  selector: 'app-paynow-layout',
  templateUrl: './paynow-layout.component.html',
  styleUrl: './paynow-layout.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    IconComponent,
    NgStyle,
    PriceComponent,
    TooltipComponent,
    ButtonComponent,
    PaymentMethodsComponent,
    ContentBlockComponent,
    AccordionComponent,
    FitTextDirective,
    PaynowBuyButtonsComponent,
    UserTokenPipe,
    PaynowFooterComponent
],
})
export class PaynowLayoutComponent implements OnInit, OnDestroy {
  protected unsubscribe = new Subject<void>()
  @Input() context!: PageContext<RedirectorPaynowConfig>
  @Input({ required: true }) usps!: {
    icon: string
    head: string
    body: string
  }[]
  protected readonly PaynowFrequentQuestions = PaynowFrequentQuestions

  constructor (
    protected dialog: MatDialog,
  ) {}

  ngOnInit () {}

  ngOnDestroy () {
    this.unsubscribe.next()
    this.unsubscribe.complete()
  }

  openPopup (): void {
    this.dialog.open(PopupComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: {
        url: `${Environment.url.app}/public/api/domain/offers/tax-info?domain=${this.context.config.name}&lang=${this.context.i18n.locale}`,
      },
    })
  }

  openPriceSuggest () {
    this.dialog.open(PriceSuggestionComponent, {
      maxHeight: '100vh',
      maxWidth: 'calc(100vw - 30px)',
      data: { context: this.context },
    })
  }
}
